<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="普货业绩" name="first">
        <GeneralCargoPerformance v-if="activeName=='first'"></GeneralCargoPerformance>
      </el-tab-pane>
      <el-tab-pane label="COD业绩" name="second">
        <CodPerformance v-if="activeName=='second'"></CodPerformance>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import GeneralCargoPerformance from './GeneralCargoPerformance/GeneralCargoPerformance'
import CodPerformance from './CodPerformance/CodPerformance'
export default {
  name: 'IndependentStationPerformance',
  components: {
    GeneralCargoPerformance,
    CodPerformance
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>
